import { Button, colors } from '@insurancemenu/imenu-components-lib';
import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';
import { createStyles } from './styles';

export interface Props {
  theme: 'white' | 'black';
  errorCode: number;
  errorTitle: string;
  errorDesc: string;
  showBackToHomeLink?: boolean;
  showHelpCenterLink?: boolean;
}

const ErrorPageContent = (props: Props): JSX.Element => {
  const { theme, errorCode, errorTitle, errorDesc, showBackToHomeLink, showHelpCenterLink } = props;
  const classes = createStyles(props);
  return (
    <div className={classes.wrapper}>
      <p className={classes.caption}>error</p>
      <h1 className={classes.title}>{errorCode}</h1>
      <h2 className={classes.subtitle}>{errorTitle}</h2>
      <p className={classes.description}>{errorDesc}</p>
      {(showBackToHomeLink || showHelpCenterLink) && (
        <div className={classes.actionBlock}>
          {showBackToHomeLink && (
            <Link to="/dashboard" className={classes.link}>
              <Button
                color="custom"
                type="contained"
                customColor={colors.neutral[theme]}
                size="large"
                width="20.6rem"
                className={clsx(props.theme === 'white' && classes.whiteHomeButton)}
              >
                Back to homepage
              </Button>
            </Link>
          )}
          {showHelpCenterLink && (
            <a href="https://insurancemenu.zendesk.com/hc/en-us" className={classes.link}>
              <Button
                color="custom"
                type="outlined"
                customColor={colors.neutral[theme]}
                size="large"
                width="20.6rem"
                className={clsx(props.theme === 'white' && classes.whiteHelpButton)}
              >
                Help center
              </Button>
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default ErrorPageContent;
